export const CPAT_TOUR_TARGETS = {
  reports: "reports-joyride",
  assessmentAvailable: "assessment-available-joyride",
}
